import { DateTime } from "luxon";
export const accordionOpenPosition = (
    hours,
    min,
    sec,
    position,
    selectedDay,
    timeZone
) => {
    const toDT = (v) => {
        if (!v) return null;
        if (DateTime.isDateTime(v)) return v;
        if (v instanceof Date) return DateTime.fromJSDate(v, { zone: timeZone });
        return DateTime.fromISO(String(v), { setZone: true });
    };

    const zone = timeZone || (DateTime.isDateTime(selectedDay) ? selectedDay.zoneName : undefined) || "UTC";

    const sel = (toDT(selectedDay) || DateTime.now().setZone(zone)).setZone(zone);
    const base = sel.startOf("day");

    const nowTZ   = DateTime.now().setZone(zone);
    const cursor  = base.hasSame(nowTZ, "day") ? nowTZ : base;

    const bound    = base.set({ hour: hours, minute: min, second: sec });
    const dayEnd   = base.set({ hour: 17, minute: 45, second: 0 });
    const dayStart = bound;
    const nightBeg = dayEnd;
    const nightEnd = bound;

    switch (position) {
        case "morning": return cursor <= bound;
        case "day":     return cursor >= dayStart && cursor <= dayEnd;
        case "night":   return cursor >= nightBeg && cursor <= nightEnd;
        default:        return false;
    }
};
